export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-latin-400-normal.woff?b0c8fe9db56dd415a25a5555f0686387";